import React, { useCallback, useMemo } from "react";
import PropTypes from "prop-types";
import isEmpty from "lodash-es/isEmpty";

import { FormTextField, FormGroupTitle } from "ui/Form";
import DialogFormWithMutation from "dialogs/DialogFormWithMutation";

import usePatchTagsData from "hooks/usePatchTagsData";

import {
  UPDATE_ACCOUNT_IQ_PATCH_TAG_FILE,
  GET_ACCOUNT_FILES_NAME,
} from "graphqlQueries/accountFiles";

import {
  UPDATE_IQ_PATCH_TAG_FILE,
  READ_VERSION_FILES_QUERY_NAME,
} from "graphqlQueries/versions";

import { createEditPatchTagValidator } from "validators/commonValidators";
import { ACCOUNT, VERSION } from "constants/patchTagSections";

const fieldsWithPlaceForError = ["patch_tag"];

const UpdatePatchTagsDialog = (props) => {
  const {
    id,
    initialValues = {
      patchTag: "",
    },
    accountId: id_ipmp,
    version,
    onClose,
    section,
  } = props;
  const getPatchTagsData = usePatchTagsData(
    {
      id_ipmp,
      version,
    },
    section,
  );

  const { mutationUpdateTag, refetch } = useMemo(() => {
    switch (section) {
      case VERSION:
        return {
          mutationUpdateTag: UPDATE_IQ_PATCH_TAG_FILE,
          refetch: READ_VERSION_FILES_QUERY_NAME,
        };
      case ACCOUNT:
        return {
          mutationUpdateTag: UPDATE_ACCOUNT_IQ_PATCH_TAG_FILE,
          refetch: GET_ACCOUNT_FILES_NAME,
        };
    }
  }, [section]);

  const data = useMemo(() => getPatchTagsData(), []);

  const dataMapper = useCallback(
    (value) => {
      let iq_patch_tags;
      if (id !== undefined) {
        iq_patch_tags = data.patchTags.map((item) =>
          item.id === id ? value.patchTag : item.patchTag,
        );
      } else {
        iq_patch_tags = data.patchTags
          .map((item) => item.patchTag)
          .concat(value.patchTag);
      }
      return { iq_patch_tags, id_ipmp, version };
    },
    [id, data],
  );

  const titlePrefix = isEmpty(initialValues.patchTag) ? "Add" : "Edit";

  return (
    <DialogFormWithMutation
      mutationQueries={mutationUpdateTag}
      refetchQueries={[refetch]}
      dataMapper={dataMapper}
      initialValues={initialValues}
      validationSchema={createEditPatchTagValidator}
      fieldsWithPlaceForError={fieldsWithPlaceForError}
      title={`${titlePrefix} patch tag`}
      submitButtonName="Save"
      className="dialog-default-width"
      onClose={onClose}
    >
      <FormGroupTitle title="Patch tag" />
      <FormTextField name="patchTag" label="Patch tag" />
    </DialogFormWithMutation>
  );
};

UpdatePatchTagsDialog.propTypes = {
  id: PropTypes.number,
  initialValues: PropTypes.shape({
    patch_tag: PropTypes.string,
  }),
  onClose: PropTypes.func.isRequired,
  accountId: PropTypes.number,
  version: PropTypes.string,
  section: PropTypes.string,
};

export default UpdatePatchTagsDialog;
